import { AlgoliaFacetCountsResponseModel } from "../../data-model/algoliaFacetCountsResponseModel";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface OrdersAssignedCountsParams {
  org_id: string;
  facet_attribute: string;
  created_at_start?: string;
  created_at_end?: string;
}

export const ordersAssignedCountsFromAlgolia = async (
  params: OrdersAssignedCountsParams,
  signal?: AbortSignal,
): Promise<AlgoliaFacetCountsResponseModel> => {
  const bearerToken = await getBearerToken();

  const raw = JSON.stringify({
    org_id: params.org_id,
    facet_attribute: params.facet_attribute,
    created_at_start: params.created_at_start,
    created_at_end: params.created_at_end,
  });

  const requestOptions: RequestInit = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    body: raw,
    ...(signal ? { signal } : {}),
  };

  try {
    const response = await fetch(
      API_ENDPOINTS.ALGOLIA_MULTI_FACET_COUNTS,
      requestOptions,
    );
    if (!response.ok) {
      throw new Error(
        `Failed to get orders assigned counts: ${response.statusText}`,
      );
    }
    const result = (await response.json()) as AlgoliaFacetCountsResponseModel;
    return result;
  } catch (error: any) {
    // ✅ Prevent false "aborted" error for non-abortable calls
    if (error.name === "AbortError") {
      console.warn("ordersAssignedCountsFromAlgolia request aborted");
    }

    console.error("ordersAssignedCountsFromAlgolia error:", error);
    throw new Error(`Failed to get orders assigned counts: ${error.message}`);
  }
};
